let _ctx = null;

function ctx() {
  if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
  return _ctx;
}

function tone({ freq = 440, duration = 0.2, type = 'sine', gain = 0.12, delay = 0 } = {}) {
  try {
    const ac = ctx();
    const osc = ac.createOscillator();
    const g   = ac.createGain();
    osc.connect(g);
    g.connect(ac.destination);
    osc.type = type;
    osc.frequency.setValueAtTime(freq, ac.currentTime + delay);
    g.gain.setValueAtTime(0, ac.currentTime + delay);
    g.gain.linearRampToValueAtTime(gain, ac.currentTime + delay + 0.005);
    g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + delay + duration);
    osc.start(ac.currentTime + delay);
    osc.stop(ac.currentTime + delay + duration + 0.02);
  } catch {}
}

function sweep({ freqFrom, freqTo, duration = 0.14, gain = 0.08, delay = 0 } = {}) {
  try {
    const ac = ctx();
    const osc = ac.createOscillator();
    const g   = ac.createGain();
    osc.connect(g);
    g.connect(ac.destination);
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freqFrom, ac.currentTime + delay);
    osc.frequency.exponentialRampToValueAtTime(freqTo, ac.currentTime + delay + duration);
    g.gain.setValueAtTime(0, ac.currentTime + delay);
    g.gain.linearRampToValueAtTime(gain, ac.currentTime + delay + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + delay + duration);
    osc.start(ac.currentTime + delay);
    osc.stop(ac.currentTime + delay + duration + 0.02);
  } catch {}
}

export const sounds = {
  click() {
    tone({ freq: 1100, duration: 0.06, gain: 0.09 });
  },

  open() {
    sweep({ freqFrom: 380, freqTo: 640, duration: 0.13, gain: 0.08 });
  },

  close() {
    sweep({ freqFrom: 620, freqTo: 340, duration: 0.12, gain: 0.07 });
  },

  success() {
    tone({ freq: 523.25, duration: 0.22, gain: 0.10 });
    tone({ freq: 783.99, duration: 0.35, gain: 0.09, delay: 0.13 });
  },

  unlock() {
    tone({ freq: 440,    duration: 0.14, gain: 0.10 });
    tone({ freq: 523.25, duration: 0.14, gain: 0.10, delay: 0.10 });
    tone({ freq: 659.25, duration: 0.32, gain: 0.12, delay: 0.20 });
  },

  error() {
    tone({ freq: 440, duration: 0.22, gain: 0.09 });
    tone({ freq: 330, duration: 0.35, gain: 0.08, delay: 0.13 });
  },

  notify() {
    tone({ freq: 880, duration: 0.5, gain: 0.10 });
  },

  demoBooked() {
    tone({ freq: 523.25, duration: 0.18, gain: 0.13 });
    tone({ freq: 659.25, duration: 0.18, gain: 0.12, delay: 0.10 });
    tone({ freq: 783.99, duration: 0.18, gain: 0.13, delay: 0.20 });
    tone({ freq: 1046.5, duration: 0.55, gain: 0.14, delay: 0.32 });
    sweep({ freqFrom: 1046.5, freqTo: 1318.5, duration: 0.3, gain: 0.09, delay: 0.85 });
  },
};

export function initSounds() {
  const handler = (e) => {
    const el = e.target.closest('button:not([disabled]), [role="button"]:not([aria-disabled="true"])');
    if (el && !el.dataset.nosound) sounds.click();
  };
  document.addEventListener('pointerdown', handler, { passive: true });
  return () => document.removeEventListener('pointerdown', handler);
}
